import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GetProductAssetModel } from '../models/product/productAssets.modal';
import { AdminQuoteListVM, DeleteQuoteListModel, QuoteItemModel } from '../models/quoteModel/quote.model';
import { ApiService } from './Common/api.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  constructor(private _api: ApiService) { }

  GetProductImage(productAssetsDetails: GetProductAssetModel) {
    return this._api.post(UrlHelperService.ProductMultipleImage, productAssetsDetails)
  }
  
  GetProductDetail(productModel: GetProductAssetModel) {
    return this._api.post(UrlHelperService.getProductAssetContent + productModel.ProductId)
  }

  CustomerAddressList() {
    return this._api.post(UrlHelperService.confirmCustomerAddressList)
  }

  GetOrderDetails(productId, id) {
    return this._api.get(UrlHelperService.CustomerOrderDetailsListing + productId + '/' + id)
  }

  CustomerQuoteAdd(quoteModel: QuoteItemModel) {
    return this._api.post(UrlHelperService.customerAddQuote, quoteModel)
  }

  QuoteImageList(productId) {
    return this._api.post(UrlHelperService.quotePageImageList + productId)
  }

  QuoteAddressList(quoteId) {
    return this._api.post(UrlHelperService.quoteAddressList + quoteId)
  }

  showAdminAllQuotelisting(adminQuoteList: AdminQuoteListVM) {
    return this._api.post(UrlHelperService.getAdminQuoteListing, adminQuoteList)
  }

  getQuoteId = new BehaviorSubject(<string>'');
  passId(id) {
    this.getQuoteId.next(id);
  }

  DeleteQuote(deleteQuoteList: DeleteQuoteListModel) {
    return this._api.post(UrlHelperService.deleteQuoteList, deleteQuoteList)
  }
}
